import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit {

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.loadChatbotScript();
  }

  loadChatbotScript(): void {
    const script1 = this.renderer.createElement('script');
    script1.type = 'text/javascript';
    script1.text = `
      window.embeddedChatbotConfig = {
        chatbotId: "IHlvMmSumnoULQBAYBRG-",
        domain: "www.chatbase.co",
        name: "SIMI"
      }
    `;
    this.renderer.appendChild(document.body, script1);

    const script2 = this.renderer.createElement('script');
    script2.type = 'text/javascript';
    script2.src = "https://www.chatbase.co/embed.min.js";
    script2.defer = true;
    script2.setAttribute('chatbotId', 'IHlvMmSumnoULQBAYBRG-');
    script2.setAttribute('domain', 'www.chatbase.co');
    this.renderer.appendChild(document.body, script2);
  }

}
